import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { PackageSearch, PlusCircle, Hand, X } from "lucide-react";

/**
 * Modal shown after the operator scans (or types) a barcode/code that
 * the catalogue does not contain. Surfaces 3 next-action buttons:
 *
 *   • «ΑΜΕΣΗ ΚΑΤΑΧΩΡΗΣΗ»  → opens QuickProductDialog (pre-fills barcode1)
 *   • «ΧΕΙΡΟΚΙΝΗΤΑ»        → opens ManualDepartmentDialog (pick dept + price)
 *   • «ΑΚΥΡΩΣΗ»            → closes; cursor returns to scanner input
 *
 * Layout is intentionally touch-grade — 56-px tall buttons, large fonts.
 */
export default function ProductNotFoundDialog({
  open,
  onOpenChange,
  barcode,
  onQuickRegister,
  onManual,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        hideClose
        className="max-w-lg p-0 gap-0 overflow-hidden"
        data-testid="not-found-dialog"
      >
        {/* Header */}
        <div className="px-6 py-5 bg-red-50 border-b-2 border-red-200 flex items-center gap-3">
          <div className="w-12 h-12 rounded-full bg-red-100 grid place-items-center shrink-0">
            <PackageSearch size={26} className="text-red-600" />
          </div>
          <div className="min-w-0">
            <div className="font-heading text-lg font-bold text-red-700">
              ΤΟ ΠΡΟΪΟΝ ΔΕΝ ΒΡΕΘΗΚΕ
            </div>
            {barcode ? (
              <div className="text-xs text-slate-600 mt-0.5">
                Κωδικός / Barcode:{" "}
                <span className="font-mono font-bold text-slate-900">{barcode}</span>
              </div>
            ) : null}
          </div>
        </div>

        {/* Buttons */}
        <div className="p-5 grid gap-3 bg-white">
          <Button
            type="button"
            onClick={onQuickRegister}
            className="h-14 text-base font-bold bg-emerald-600 hover:bg-emerald-700 text-white"
            data-testid="not-found-quick-register-btn"
          >
            <PlusCircle size={20} className="mr-2" />
            ΑΜΕΣΗ ΚΑΤΑΧΩΡΗΣΗ
          </Button>
          <Button
            type="button"
            onClick={onManual}
            className="h-14 text-base font-bold bg-indigo-600 hover:bg-indigo-700 text-white"
            data-testid="not-found-manual-btn"
          >
            <Hand size={20} className="mr-2" />
            ΧΕΙΡΟΚΙΝΗΤΑ (επιλογή τμήματος)
          </Button>
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
            className="h-12 text-sm font-bold"
            data-testid="not-found-cancel-btn"
          >
            <X size={18} className="mr-2" />
            ΑΚΥΡΩΣΗ
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
